<script setup lang="ts">
import TechnoFrame from "@/components/Common/TechnoFrame.vue";
import ScreenshotCarousel from "@/components/MainPage/PcVersion/ScreenshotsCarousel.vue";
import GameInfo from "@/components/MainPage/PcVersion/GameInfo.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'GreetingsHolder',

    data() {
        return {
        }
    },
})
</script>

<template>
    <div class="contentBox">
        <TechnoFrame
            :offset="5"
            :size-modifier="0.3"
        />

        <div class="contentHolder">
            <div class="columns">
                <div class="column">
                    <GameInfo/>
                </div>

                <div class="column">
                    <ScreenshotCarousel/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.contentBox {
    position: relative;
    width: 1000px;
    background: rgba(15, 15, 15, 0.85);
    border-radius: 20px 20px 30px 30px;
    box-shadow: 0 0 20px 5px rgba(20, 20, 20, 1.0);

    background-image: v-bind('`url("/img/page/landing/main/bg/1.jpg")`');
    background-size: cover;
    background-position: center center;
}

.contentHolder {
    width: 100%;
    padding: 30px 50px 40px 50px;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
}

h5 {
    color: #ff9700;
    text-shadow: 0 0 10px black;
}

.columns {
    display: flex;
    flex-direction: row;
    gap: 30px;
    justify-content: center;
    align-items: center;
}

.column {
    display: flex;
    flex-direction: column;
    width: 50%;
    gap: 10px;
}
</style>
